import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import profiles from './pivot-profiles.json';
import { member } from './fixedWindows';

const cache = new Map();
export function assemblePivot(parent, code, sides, width, height, roles, flip = false, mirrorDepth = false) {
  const profile = profiles[code];
  const key = `${code}:${flip}:${mirrorDepth}`;
  const point = ([x, y]) => new THREE.Vector2((mirrorDepth ? profile.depth_mm - x : x) / 1000, (flip ? profile.height_mm - y : y) / 1000);
  if (!cache.has(key)) cache.set(key, profile.components.filter(c => c.shapes.length).map(c => {
    const shapes = c.shapes.map(s => {
      const outer = new THREE.Shape(s.outer.map(point));
      s.holes.forEach(h => outer.holes.push(new THREE.Path(h.map(point))));
      return outer;
    });
    return { role: c.role, geometry: new THREE.ExtrudeGeometry(shapes, { depth: 1, bevelEnabled: false, steps: 1, curveSegments: 3 }) };
  }));
  for (const { role, geometry } of cache.get(key)) {
    const parts = sides.map(side => member(geometry, side, width, height).translate(0, 0, -profile.depth_mm / 2000));
    const mesh = new THREE.Mesh(mergeGeometries(parts, false), roles[role] || roles.frame);
    parts.forEach(g => g.dispose()); mesh.castShadow = true; mesh.receiveShadow = true;
    Object.assign(mesh.userData, { profileCode: code, profileRole: role, profileDepthMm: profile.depth_mm }); parent.add(mesh);
  }
}